export default function(data) {
var __t, __p = '';
__p += '<span class="tooltip">\n  <span class="tooltip-trigger">\n    ' +
((__t = ( this.tooltipTrigger )) == null ? '' : __t) +
'\n  </span>\n  <span class="tooltip-content">\n    ' +
((__t = ( this.tooltipContent )) == null ? '' : __t) +
'\n  </span>\n</span>\n';
return __p
}